import { host } from "../../../utils/constants";

const defaultHost = host ?? "https://backend.clamphook.com";

export const getAllBoardList = defaultHost + "/eu/boex/board_list";

export const getUpcomingTestList = defaultHost + "/eu/boex/featured";

export const getClassroom = defaultHost + "/eu/classroom/";

export const getAllSubjects = defaultHost + "/eu/content/subject";

export const getAllClassrooms = defaultHost + "/eu/classroom/all_classes";

export const getFeaturedClassrooms = defaultHost + "/eu/classroom/featured";

export const getDemoVideos = defaultHost + "/eu/classroom/demo_videos";

export const getBoard = defaultHost + "/eu/boex/board/";

export const getSubject = defaultHost + "/eu/content/subject/";

export const getSubjectSessions = defaultHost + "/eu/content/subject/";

export const getChapter = defaultHost + "/eu/content/chapter/";

export const getChapterSet = defaultHost + "/eu/content/questions/chapter_set/";

export const postImage = defaultHost + "/commons/images/";

export const getSet = defaultHost + "/eu/boex/exam/";

export const getAllGoals = defaultHost + "/eu/goal/list";

export const getExamInfo = defaultHost + "/cbt/info/";

export const registerExam = defaultHost + "/eu/exam/shift/register/";

export const getBoardExams = defaultHost + "/eu/exam/all/";

export const postContactForm = defaultHost + "/eu/contact-us/";

export const submitImageForPayment =
  defaultHost + "/eu/classroom/registration/image/";

export const submitPublicQuestion = defaultHost + "/eu/question/";

export const getIoeColleges = defaultHost + "/eu/colleges/ioe_list";

export const getClassroomPreview = defaultHost + "/eu/classroom/";
// Usage: getClassroomPreview + classroomId + "/preview"

export const getVideoPreviewUrl = defaultHost + "/eu/video/";
// Usage: getVideoPreviewUrl + sessionId + "/preview-url"

// Usage: getClassroomSections + classroomId
export const getClassroomSections = defaultHost + "/eu/classroom/sections/";
